import React from 'react';

const Header = () => (
    <div className="header__container">
      <div className="header__container-inner">
        <div>
          <h2 className="title is-4 has-text-centered has-text-weight-bold">Bans on personal spending</h2>
          <h2 className="subtitle is-6 has-text-centered">Pennsylvania is one of only two states that don't explicitly ban or limit candidates from spending campaign donations on personal expenses.
          </h2>
        </div>
      </div>
    </div>
)

export default Header